import { render, staticRenderFns } from "./SalaryForm.vue?vue&type=template&id=0da3b20f&scoped=true&"
import script from "./SalaryForm.vue?vue&type=script&lang=js&"
export * from "./SalaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da3b20f",
  null
  
)

export default component.exports